import { forwardRef } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const IconCopy_24 = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 24 24"
    data-fill-none
  >
    <path
      d="M7.56994 22.6885H21.0971C21.976 22.6885 22.6885 21.976 22.6885 21.0971V7.56994C22.6885 6.69101 21.976 5.97852 21.0971 5.97852H7.56994C6.69101 5.97852 5.97852 6.69101 5.97852 7.56994V21.0971C5.97852 21.976 6.69101 22.6885 7.56994 22.6885Z"
      stroke="currentColor"
      strokeWidth="1.72"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 17.9143V3.59143C2 3.16935 2.16767 2.76457 2.46612 2.46612C2.76457 2.16767 3.16935 2 3.59143 2H17.9143"
      stroke="currentColor"
      strokeWidth="1.72"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
));
IconCopy_24.displayName = 'IconCopy_24';
